<section class="auth-page-shell scrollable-container">
  <div class="auth-page-bg">
    <div class="container auth-page-container">
      <div class="auth-card auth-card-wide">

        <div class="auth-form-panel">
          <div class="auth-form-heading">
            <div>
            <img
              :src="$sideLogo"
              class="img-fluid mx-auto d-block w-200 w-md-150"
              alt=""
            />

            <p v-if="bosa_domain" class="fw-bold text-center mb-2 mt-4">Welcome to BOSA Connect <br>A civic engagement platform</p>
          </div>
          </div>

           <h4 class="fw-bold mt-4 d-flex justify-content-center">
             {{ is_organization_registration() ? 'Register an organisation' : 'Create your account' }}
           </h4>
           <p class="auth-switch-text mt-2 mb-3">
             {{ is_organization_registration()
               ? 'Want to join an existing organisation?'
               : 'Want to create an organisation?' }}
             <router-link :to="get_registration_switch_route()" class="auth-link">
               {{ is_organization_registration() ? 'Create a personal account' : 'Register an organisation' }}
             </router-link>
           </p>
            <p class="d-none text-muted">Fill in your details to create your account.</p>

          <form class="auth-form" @submit.prevent="register_user">

            <div v-if="is_organization_registration()" class="auth-organization-fields">

              <div class="row auth-form-row">
                <div class="col-12 col-md-6">
                  <div class="auth-field">
                    <label for="organization_name" class="form-label">Organisation name<span class="text-danger">*</span></label>
                    <div class="auth-field-shell">
                      <i class="bi bi-building auth-input-icon"></i>
                      <input
                        type="text"
                        :class="['form-control', { 'is-invalid': errors.organization_name }]"
                        id="organization_name"
                        placeholder="Organisation name"
                        v-model="organization_name"
                        required
                      >
                    </div>
                    <span v-if="errors.organization_name" class="auth-error">{{ errors.organization_name }}</span>
                  </div>
                </div>

                <div class="col-12 col-md-6">
                  <div class="auth-field">
                    <label for="type_of_organization" class="form-label">Type of organisation<span class="text-danger">*</span></label>
                    <div class="auth-field-shell">
                      <i class="bi bi-diagram-3 auth-input-icon"></i>
                      <select
                        id="type_of_organization"
                        class="form-control form-control-sm text-muted"
                        v-model="selected_type_of_organization"
                        required
                      >
                        <option value="" disabled>Organisation type</option>
                        <option
                          v-for="organization_type in type_of_organization"
                          :key="organization_type.id"
                          :value="organization_type.id"
                        >
                         {{ organization_type.type_of_organization.replace('_', ' ').toUpperCase() }}
                        </option>
                        <option value="other">Other</option>
                      </select>
                    </div>
                    <div v-if="selected_type_of_organization === 'other'" class="auth-field-shell auth-field-shell-spaced">
                      <i class="bi bi-pencil auth-input-icon"></i>
                      <input
                        type="text"
                        class="form-control"
                        id="custom_type_of_organization"
                        placeholder="Example: Church, Foundation, Cooperative, Sports Club"
                        v-model="custom_type_of_organization"
                        :required="selected_type_of_organization === 'other'"
                      >
                    </div>
                    <span v-if="errors.type_of_organization_id" class="auth-error">{{ errors.type_of_organization_id }}</span>
                  </div>
                </div>
              </div>

              <div class="auth-field">
                <label class="form-label">Organisation access<span class="text-danger">*</span></label>
                <div class="d-flex flex-wrap gap-3" role="radiogroup" aria-label="Organisation access">
                  <div class="form-check">
                    <input
                      id="organization_access_private"
                      class="form-check-input"
                      type="radio"
                      name="organization_access"
                      value="private"
                      v-model="organization_access"
                    >
                    <label class="form-check-label" for="organization_access_private">
                      <span class="d-block fw-bold">Private</span>
                      <small class="d-block fw-semibold text-muted">Join by invitation.</small>
                    </label>
                  </div>
                  <div class="form-check">
                    <input
                      id="organization_access_public"
                      class="form-check-input"
                      type="radio"
                      name="organization_access"
                      value="public"
                      v-model="organization_access"
                    >
                    <label class="form-check-label" for="organization_access_public">
                      <span class="d-block fw-bold">Public</span>
                      <small class="d-block fw-semibold text-muted">Publicly discoverable.</small>
                    </label>
                  </div>
                </div>
                <span v-if="errors.organization_access" class="auth-error">{{ errors.organization_access }}</span>
              </div>
            </div>

            <div class="row auth-form-row">
              <div class="col-12 col-md-6">
                <div class="auth-field">
                  <label for="first_name" class="form-label">First Name<span class="text-danger">*</span></label>
                  <div class="auth-field-shell">
                    <i class="bi bi-person auth-input-icon"></i>
                    <input
                      type="text"
                      class="form-control text-xxs"
                      placeholder="Enter your first name"
                      id="first_name"
                      v-model="first_name"
                      required
                    >
                  </div>
                  <span v-if="errors.first_name" class="auth-error">{{ errors.first_name }}</span>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auth-field">
                  <label for="last_name" class="form-label">Last Name<span class="text-danger">*</span></label>
                  <div class="auth-field-shell">
                    <i class="bi bi-person auth-input-icon"></i>
                    <input
                      type="text"
                      class="form-control"
                      id="last_name"
                      placeholder="Enter last name"
                      v-model="last_name"
                      required
                    >
                  </div>
                  <span v-if="errors.last_name" class="auth-error">{{ errors.last_name }}</span>
                </div>
              </div>
            </div>

            <div class="auth-field">
              <label for="email" class="form-label">Email<span class="text-danger">*</span></label>
              <div class="auth-field-shell">
                <i class="bi bi-envelope auth-input-icon"></i>
                <input
                  type="email"
                  :class="['form-control', { 'is-invalid': errors.email }]"
                  placeholder="example@gmail.com"
                  id="email"
                  v-model="email"
                  required
                >
              </div>
              <span v-if="errors.email" class="auth-error">{{ errors.email }}</span>
            </div>

            <div class="auth-field">
              <label for="phone_number" class="form-label">Phone number</label>
              <div class="auth-field-shell">
                <i class="bi bi-telephone auth-input-icon"></i>
                <input
                  type="tel"
                  inputmode="numeric"
                  pattern="^\+?[0-9]*$"
                  class="form-control"
                  id="phone_number"
                  placeholder="Enter phone number"
                  v-model="phone_number"
                  @input="phone_number = phone_number.replace(/(?!^\+)\D/g, '')"
                >
              </div>
            </div>

            <div class="auth-field" v-if="school_domain">
              <label for="user_type" class="form-label">I am a<span class="text-danger">*</span></label>
              <div class="auth-field-shell">
                <i class="bi bi-person-badge auth-input-icon"></i>
                <select id="user_type" class="form-control" v-model="user_type" required>
                  <option value="parent">Parent</option>
                  <option value="teacher">Teacher</option>
                </select>
              </div>
            </div>

            <div class="row auth-form-row">
              <div class="col-12 col-md-6">
                <div class="auth-field">
                  <label for="password" class="form-label">Password<span class="text-danger">*</span></label>
                  <div class="auth-field-shell">
                    <i class="bi bi-lock auth-input-icon"></i>
                    <input
                      :type="passwordVisible ? 'text' : 'password'"
                      class="form-control"
                      id="password"
                      placeholder="Enter password"
                      v-model="password"
                      required
                    >
                    <button
                      type="button"
                      class="auth-eye-toggle"
                      @click="togglePasswordVisibility('password')"
                      aria-label="Toggle password visibility"
                    >
                      <i :class="passwordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                    </button>
                  </div>
                  <span v-if="errors.password" class="auth-error">{{ errors.password }}</span>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <div class="auth-field">
                  <label for="confirm_password" class="form-label">Confirm password<span class="text-danger">*</span></label>
                  <div class="auth-field-shell">
                    <i class="bi bi-lock-fill auth-input-icon"></i>
                    <input
                      :type="confirmPasswordVisible ? 'text' : 'password'"
                      class="form-control"
                      id="confirm_password"
                      placeholder="Confirm password"
                      v-model="confirm_password"
                      required
                    >
                    <button
                      type="button"
                      class="auth-eye-toggle"
                      @click="togglePasswordVisibility('confirm')"
                      aria-label="Toggle confirm password visibility"
                    >
                      <i :class="confirmPasswordVisible ? 'bi bi-eye' : 'bi bi-eye-slash'"></i>
                    </button>
                  </div>
                  <span v-if="errors.confirm_password" class="auth-error">{{ errors.confirm_password }}</span>
                </div>
              </div>
            </div>

            <button type="submit" class="btn auth-submit-btn" :disabled="is_registering">
              <span
                v-if="is_registering"
                class="spinner-border spinner-border-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              {{ is_registering
                ? (is_organization_registration() ? 'Creating organisation...' : 'Creating account...')
                : (is_organization_registration() ? 'Create organisation' : 'Create account') }}
            </button>

            <p class="auth-switch-text">
              Already have an account?
              <router-link to="/login" class="auth-link">Login</router-link>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
